import src from "IMAGE";
export default { src, width: 200, height: 50, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/AIBk2s9fS5+TCQcPLAQEBCUEBAQiBAQEJQUFBS8FBQU1AIBl289cSZuOCQcOLwYGBjYGBgY2BgYGNQUFBTIFBQU33M4LzzyhOO0AAAAASUVORK5CYII="};
